module.exports = __webpack_public_path__ + "static/media/museum.5dc671a7.jpg";